export * from './confirm-attendance-page.component';
